export function IconDocument({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M3 1h7l4 4v10H3zm1.5 1.5v11h8V6h-3V2.5zm5 1V5H11zM5.5 8h6v1.5h-6zm0 3h4v1.5h-4z"
      />
    </svg>
  );
}
